import useSWRMutation from "swr/mutation";
import { storefrontGraphql } from "../../../components/common/storefront";
import type { StoreCode } from "../../../libs/models/shopify/storeCodeSchema";

export const getAdditionalAttributes = () => {
  return [
    ...Array.from(new URL(location.href).searchParams).reduce<
      Array<{ key: string; value: string }>
    >((acc, [key, value]) => {
      if (!key.startsWith("utm_")) return acc;
      acc.push({ key: `_${key}`, value });
      return acc;
    }, []),
    {
      key: "_source",
      value: `${location.origin}${location.pathname}`,
    },
  ];
};

type FetcherArg = {
  arg: { merchandiseId: string; attributes: Array<{ key: string; value: string }> };
};

export const useCreateCart = (store: StoreCode) => {
  const {
    data: checkoutUrl,
    trigger: createCart,
    isMutating,
  } = useSWRMutation(["storefront:cart-create", store], async ([, s], { arg }: FetcherArg) => {
    const data = await storefrontGraphql<CreateCartResponse>(s, query, {
      input: {
        lines: [
          {
            merchandiseId: arg.merchandiseId,
            quantity: 1,
            attributes: [...arg.attributes, ...getAdditionalAttributes()],
          },
        ],
      } satisfies CartInput,
    });
    return data.cartCreate.cart.checkoutUrl;
  });

  return { checkoutUrl, createCart, isLoading: isMutating };
};

type CartInput = {
  lines: Array<{
    merchandiseId: string;
    quantity: number;
    attributes: Array<{ key: string; value: string }>;
  }>;
};

type CreateCartResponse = {
  cartCreate: {
    cart: {
      checkoutUrl: string;
    };
    userErrors: Array<{
      field: string;
      message: string;
    }>;
  };
};

const query = `
  mutation createCart($input: CartInput!) {
    cartCreate(input: $input) {
      cart {
        checkoutUrl
      }
      userErrors {
        field
        message
      }
    }
  } 
`;
